import { Filter, BlurFilter } from '@tencent/alloy-renderer';
import { ColorAdjustmentFilter, SharpenFilter } from '@tencent/alloy-renderer-tdoc';
import { IImageFilter } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-graphic/graphic-component.interface';
import { FORBID_WEBGL_FILTER } from '@src/slide/infrastructure/module/dependent/config/renderer/switch';
import { ImagePropsField } from '@src/slide/domain/ui-model/element-modeles/property/image-operation/constant/props-value';

export class ImageFilter {
    public static generateImageFilter = (imageFilter: IImageFilter): Filter[] => {
        const { brightness, colorTemperature, contrast, saturate, sharpenSoften } = imageFilter;
        const colorAdjustmentFilter = new ColorAdjustmentFilter({
            brightness: ImageFilter.getBrightnessValue(brightness),
            contrast: ImageFilter.getContrastValue(contrast),
            saturate: ImageFilter.getSaturateValue(saturate),
            temperature: colorTemperature,
        });
        colorAdjustmentFilter.forbidWebgl = FORBID_WEBGL_FILTER;
        const filters: Filter[] = [colorAdjustmentFilter];

        if (sharpenSoften > 0) {
            const sharpenFilter = new SharpenFilter({ size: sharpenSoften / 100 });
            sharpenFilter.forbidWebgl = FORBID_WEBGL_FILTER;
            filters.push(sharpenFilter);
        } else if (sharpenSoften < 0) {
            const radius = -sharpenSoften / 10 * 4;
            const blurFilter = new BlurFilter({ radiusX: radius, radiusY: radius, maxPadX: 0, maxPadY: 0 });
            blurFilter.forbidWebgl = FORBID_WEBGL_FILTER;
            filters.push(blurFilter);
        }
        return filters;
    };

    /**
     * 是否对 image 增加滤镜
     * 所有属性为默认值时不添加滤镜
     */
    public static isShowImageFilter = (image: IImageFilter): boolean => {
        if (!image) return false;
        const { sharpenSoften, contrast, colorTemperature, brightness, saturate } = image;
        return sharpenSoften !== ImagePropsField.ClARITY.defaultValue
            || contrast !== ImagePropsField.CONTRAST.defaultValue
            || colorTemperature !== ImagePropsField.COLORTEMPERATURE.defaultValue
            || brightness !== ImagePropsField.BRIGHTNESS.defaultValue
            || saturate !== ImagePropsField.SATURATE.defaultValue;
    };

    // 计算亮度值
    public static getBrightnessValue = (val: number): number => {
        if (!val) return 1;
        if (val < 0) return (val / 100) + 1;
        return val !== 100 ? (1 / (1 - (val / 100))) : 100;
    };

    // 计算对比度的值
    public static getContrastValue = (val: number): number => {
        const value = val / 100;
        return value < 0 ? value + 1 : 1 + (value / 0.6);
    };

    // 计算饱和度值
    public static getSaturateValue = (val = 100): number => val / 100;
}
